import React from "react";
import { Tag, Typography } from "antd";
import { NextStepItem } from "../../../../Service/application.insight.service";

const FinalStepCard = ({ step }: { step: NextStepItem }) => (
  <div className="aic-skill-card">
    <div className="aic-skill-card-header">
      <Typography.Text strong>{step.skill}</Typography.Text>
      <Tag color={step.severity === "high" ? "error" : "warning"}>
        {step.severity === "high" ? "Must-Have" : "Nice-to-Have"}
      </Tag>
    </div>
    <Typography.Text type="secondary" style={{ fontStyle: "italic" }}>
      "{step.reason}"
    </Typography.Text>
  </div>
);

interface FinalStepBlockProps {
  topNextSteps: NextStepItem[];
}

const FinalStepBlock: React.FC<FinalStepBlockProps> = ({ topNextSteps }) => {
  const probSteps = topNextSteps.filter((n) => n.group === "probe_in_interview");
  const verifySteps = topNextSteps.filter((n) => n.group === "verify_before_shortlisting");

  return (
    <div className="aic-skill-match">
      {probSteps.length > 0 && (
        <div>
          <div className="aic-header-title">
            <span
              className="material-symbols-outlined"
              data-icon="lightbulb"
              style={{ color: "#000000", fontSize: "16px" }}
            >
              lightbulb
            </span>
            <Typography.Title style={{ margin: 0 }} level={5}>
              Next Steps
            </Typography.Title>
          </div>
          <div className="skill-card-wrapper">
            {probSteps.map((p, i) => (
              <FinalStepCard step={p} key={i} />
            ))}
          </div>
        </div>
      )}
      {verifySteps.length > 0 && (
        <div>
          <div className="aic-header-title">
            <span
              className="material-symbols-outlined"
              data-icon="checklist"
              style={{ color: "#000000", fontSize: "16px" }}
            >
              checklist
            </span>
            <Typography.Title level={5} style={{ margin: 0 }}>
              Verify Before Shortlisting
            </Typography.Title>
          </div>
          <div className="skill-card-wrapper">
            {verifySteps.map((v, i) => (
              <FinalStepCard step={v} key={i} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default FinalStepBlock;
